import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("apps", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateApps = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateApps?.destroy();
  },
});
